import { RouteConfig } from "vue-router"
import { ROLES } from "@/constants/roles"

export const timeOfUseRoutes: RouteConfig[] = [
    {
        path: "time-of-use",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: {
            title: "time_of_use.bc_title",
            maintainsContext: true,
            requiresAuth: true,
            permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
        },
        children: [
            {
                path: "",
                name: "TimeOfUse",
                component: () => import("@/views/time-of-use/TimeOfUse.vue"),
                meta: {
                    title: "Time of use",
                    maintainsContext: true,
                    requiresAuth: true,
                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                },
            },
            {
                path: "new",
                name: "TimeOfUseCreate",
                component: () => import("@/views/time-of-use/TimeOfUseEdit.vue"),
                meta: {
                    title: "Time of use",
                    maintainsContext: true,
                    requiresAuth: true,
                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                },
            },
            {
                path: ":id",
                name: "TimeOfUseEdit",
                component: () => import("@/views/time-of-use/TimeOfUseEdit.vue"),
                meta: {
                    title: "Time of use",
                    maintainsContext: true,
                    requiresAuth: true,
                    permissions: [ROLES.ADMIN, ROLES.AGGREGATOR],
                },
            },
        ],
    },
]